import React from 'react'
import { StyledIconPropsType } from './types'

type Props = StyledIconPropsType &  { custom?: boolean }

const TruckWMO = ({
  icon = "delivery",
  viewBox= "0 0 32 32",
  width = "32px",
  height = "32px",
  customProps = {},
  custom = false
} : Props) => {
  if(custom) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none" {...customProps}>
        <path d="M26.666 5H1.66602V26.6667H26.666V5Z" stroke="#5E5E65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M26.666 13.3335H33.3327L38.3327 18.3335V26.6668H26.666V13.3335Z" stroke="#5E5E65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9.16667 34.9998C11.4679 34.9998 13.3333 33.1344 13.3333 30.8332C13.3333 28.532 11.4679 26.6665 9.16667 26.6665C6.86548 26.6665 5 28.532 5 30.8332C5 33.1344 6.86548 34.9998 9.16667 34.9998Z" stroke="#5E5E65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M30.8327 34.9998C33.1339 34.9998 34.9993 33.1344 34.9993 30.8332C34.9993 28.532 33.1339 26.6665 30.8327 26.6665C28.5315 26.6665 26.666 28.532 26.666 30.8332C26.666 33.1344 28.5315 34.9998 30.8327 34.9998Z" stroke="#5E5E65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  }

  return (
    <svg aria-label={icon} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none" {...customProps}>
      <path d="M21.332 4H1.33203V21.3333H21.332V4Z" stroke="#5C5C5C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21.332 10.668H26.6654L30.6654 14.668V21.3346H21.332V10.668Z" stroke="#5C5C5C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.33333 28.0007C9.17428 28.0007 10.6667 26.5083 10.6667 24.6673C10.6667 22.8264 9.17428 21.334 7.33333 21.334C5.49238 21.334 4 22.8264 4 24.6673C4 26.5083 5.49238 28.0007 7.33333 28.0007Z" stroke="#5C5C5C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M24.6654 28.0007C26.5063 28.0007 27.9987 26.5083 27.9987 24.6673C27.9987 22.8264 26.5063 21.334 24.6654 21.334C22.8244 21.334 21.332 22.8264 21.332 24.6673C21.332 26.5083 22.8244 28.0007 24.6654 28.0007Z" stroke="#5C5C5C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default TruckWMO
